/* Jasumati - faster colour-variant image switching.
   1. Product cards and the sticky buy bar: the theme swapped in the original full-size
      upload (1-2 MB and more) on every swatch tap. They now get a right-sized image,
      and cards warm up their other colours on hover/touch.
   2. Product page: the main photo of each colour is fetched ahead of time, when the
      browser is idle, so the gallery can show it straight away. */
(function () {
  'use strict';

  var STEPS = [240, 330, 480, 550, 660, 720, 900, 1100, 1500];

  function fileName(url) {
    return String(url || '').split('?')[0].split('/').pop();
  }

  /* Shopify CDN url for `src`, sized for the slot `img` occupies on this screen. */
  function sizedUrl(src, img, maxWidth) {
    if (!src) return src;
    var slot = (img && img.getBoundingClientRect().width) || 360;
    var need = Math.ceil(slot * Math.min(window.devicePixelRatio || 1, 3));
    var width = STEPS[STEPS.length - 1];
    for (var i = 0; i < STEPS.length; i++) {
      if (STEPS[i] >= need) {
        width = STEPS[i];
        break;
      }
    }
    if (maxWidth && width > maxWidth) width = maxWidth;
    var clean = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function readVariants(host) {
    var json = host && host.querySelector('[type="application/json"]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  /* ---- Right-sized images when the theme swaps a variant photo --------- */

  /* The theme sets these <img> elements to the variant's original upload. Wrap the
     method so it receives a url sized for the slot instead (cards and sticky bar). */
  function patchMedia(elementName, method, findImg) {
    var defined = window.customElements && customElements.get(elementName);
    var proto = defined && defined.prototype;
    while (proto && !Object.prototype.hasOwnProperty.call(proto, method)) {
      proto = Object.getPrototypeOf(proto);
    }
    if (!proto || typeof proto[method] !== 'function' || proto[method].jasSized) return;

    var original = proto[method];
    var sized = function () {
      var variant = this.currentVariant;
      var preview = variant && variant.featured_media && variant.featured_media.preview_image;
      var img = findImg(this);
      if (!preview || !preview.src || !img) return original.apply(this, arguments);

      var full = preview.src;
      preview.src = sizedUrl(full, img, preview.width);
      try {
        return original.apply(this, arguments);
      } finally {
        preview.src = full;
      }
    };
    sized.jasSized = true;
    proto[method] = sized;
  }

  function cardImage(element) {
    return element.productTarget && element.productTarget.querySelector('.product__media img');
  }

  function stickyBarImage(element) {
    var bar = element.productTarget && element.productTarget.querySelector('sticky-add-cart');
    return bar && bar.querySelector('img');
  }

  function patchAll() {
    patchMedia('variant-radios', 'updateMedia', cardImage);
    patchMedia('variant-radios-detail', 'updateMediaSticky', stickyBarImage);
    patchMedia('variant-group-detail', 'updateMediaSticky', stickyBarImage);
  }

  /* ---- Product cards: warm up the other colours on hover / touch -------- */

  var warmedCards = typeof WeakSet === 'function' ? new WeakSet() : null;

  function warmCard(radios) {
    if (!warmedCards || warmedCards.has(radios)) return;
    warmedCards.add(radios);

    var card = radios.closest('.product__item-js');
    var img = card && card.querySelector('.product__media img');
    if (!img) return;

    var shown = fileName(img.currentSrc || img.src);
    var seen = {};
    readVariants(radios).forEach(function (variant) {
      var preview = variant.featured_media && variant.featured_media.preview_image;
      if (!preview || !preview.src || seen[preview.src]) return;
      seen[preview.src] = true;
      if (fileName(preview.src) === shown) return;
      var warm = new Image();
      warm.decoding = 'async';
      warm.src = sizedUrl(preview.src, img, preview.width);
    });
  }

  function onIntent(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var radios = target.closest('variant-radios');
    if (radios) warmCard(radios);
  }

  /* ---- Product page ---------------------------------------------------- */

  function warmProductPage() {
    var connection = navigator.connection;
    if (connection && connection.saveData) return;

    var radios = document.querySelector('variant-radios-detail, variant-group-detail');
    var gallery = document.querySelector('media-gallery');
    if (!radios || !gallery) return;

    var seen = {};
    readVariants(radios).forEach(function (variant) {
      var media = variant.featured_media;
      if (!media || !media.id || seen[media.id]) return;
      seen[media.id] = true;
      var slide = gallery.querySelector('[data-media-id$="-' + media.id + '"]');
      var img = slide && slide.querySelector('img');
      if (img && !img.complete && img.getAttribute('loading') === 'lazy') {
        img.setAttribute('loading', 'eager');
      }
    });
  }

  function whenIdle(task) {
    function schedule() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(task, { timeout: 3000 });
      } else {
        window.setTimeout(task, 1200);
      }
    }
    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
    }
  }

  /* ---- Start ----------------------------------------------------------- */

  patchAll();
  if (window.customElements && customElements.whenDefined) {
    ['variant-radios', 'variant-radios-detail', 'variant-group-detail'].forEach(function (name) {
      customElements.whenDefined(name).then(patchAll);
    });
  }

  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);

  whenIdle(warmProductPage);
})();
